var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg7 = function Svg7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 592 592"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#313030",
    d: "M292.832 11.415C133.311 11.415 4 140.725 4 300.241s129.311 288.786 288.832 288.786c159.519 0 288.831-129.269 288.831-288.786 0-159.516-129.312-288.826-288.831-288.826"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 13.323,
    d: "M295.696 7C136.173 7 6.861 136.31 6.861 295.825c0 159.517 129.312 288.786 288.835 288.786 159.517 0 288.831-129.269 288.831-288.786C584.527 136.31 455.213 7 295.696 7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4EA08",
    d: "M160.213 128.764h270.96v62.667c-23.545 21.268-43.212 44.28-59.013 69.053-19.146 30.081-34.267 63.575-45.359 100.492-8.815 28.723-14.733 62.667-17.773 101.868h-92.522c7.295-54.535 18.76-100.265 34.415-137.187 15.64-36.918 40.413-76.425 74.292-118.506h-165z"
  })));
};
export default Svg7;